import { render } from "./Mine.vue?vue&type=template&id=2d05fe06&scoped=true"
import script from "./Mine.vue?vue&type=script&lang=js"
export * from "./Mine.vue?vue&type=script&lang=js"

import "./Mine.vue?vue&type=style&index=0&id=2d05fe06&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2d05fe06"

export default script